import React, { useMemo } from "react";

import FiltersForm from "../../components/FiltersForm";
import { NORMAL_START_OPTIONS, VARIABLE_OPTIONS } from "./climateCopy";

/**
 * The primary filter row, shared by the Monthly Climate Comparison page and
 * its embed so the two offer exactly the same choices.
 *
 * Only the three filters that change what is being measured live here. The
 * display toggles that add or remove series from the chart - comparison years,
 * units, the second station - sit in the "Additional Graph Filters" fieldset
 * under the chart, the way Reservoir Inflow Comparisons and Year Comparison
 * do it.
 */
export default function ClimateMonthlyControls({
  params,
  onChange,
  waterYears = [],
}) {
  const FILTERS_CONFIG = useMemo(
    () => [
      {
        type: "select",
        param: "variable",
        label: "Variable",
        default: params.variable,
        options: VARIABLE_OPTIONS,
      },
      {
        type: "select",
        param: "water_year",
        label: "Water Year",
        default: String(params.water_year),
        options: waterYears.map((year) => ({
          label: `WY${year}`,
          value: String(year),
        })),
      },
      {
        type: "select",
        param: "normal_start",
        label: "Normal Start Year",
        default: String(params.normal_start),
        options: NORMAL_START_OPTIONS,
      },
    ],
    [params, waterYears]
  );

  return <FiltersForm config={FILTERS_CONFIG} onChange={onChange} />;
}
